<template>
    <div class="redesign-widget-ai-parameter">
        <RedesignBaseButton
            size="small"
            icon="Edit"
            @click="openModal"
        >
            {{ $t('widget.ai.setupTemplate') }}
        </RedesignBaseButton>

        <!-- AI Parameter Modal -->
        <AiParameterModal
            :visible="modalVisible"
            :config="value"
            :parameter-groups="parameterGroups"
            :is-loading="isLoading"
            @save="onSave"
            @update:visible="val => modalVisible = val"
        />
    </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted } from 'vue'
import RedesignBaseButton from '@/components/RedesignBaseComponents/Buttons/RedesignBaseButton.vue'
import AiParameterModal from '@/components/RedesignComponents/Modal/AiParameterModal.vue'

import { WidgetConfig } from '@/types/dashboard'
import {
    getTemplateParameterHelpDescription,
    getTemplateParameterHelpName
} from '@/components/RedesignComponents/Widgets/widget.helper'
import { useAiParameterData } from '@/composables/useAiParameterData'

const props = defineProps<{
    value: WidgetConfig
}>()

const emit = defineEmits<{
    (e: 'input', value: WidgetConfig): void
    (e: 'update:value', value: WidgetConfig): void
}>()

const modalVisible = ref(false)

// Use the composable to fetch parameter data from 3 sources
const {
    parameterGroups,
    isLoading,
    fetchAllData
} = useAiParameterData()

// Computed for template helper
const templateParameterHelpName = computed(() => {
    return getTemplateParameterHelpName(props.value)
})

const templateParameterHelpDescription = computed(() => {
    return getTemplateParameterHelpDescription(props.value)
})

function openModal () {
    modalVisible.value = true
}

function onSave (config: WidgetConfig) {
    emit('input', config)
    emit('update:value', config)
}

// Fetch parameter data on mount
onMounted(() => {
    fetchAllData()
})
</script>

<style lang="scss">
.redesign-widget-ai-parameter {
    @apply mb-4;
}
</style>
